export const getRedirectDomain = (email) => {
	const domainFromEmail = email.split('@')[1]
        switch (domainFromEmail) {
            case 'gmail.com':
                return 'mail.google.com';
            case 'yahoo.com':
            case 'yahoo.de':
                return 'mail.yahoo.com';
            case 'outlook.com':
            case 'hotmail.com':
            case 'live.com':
                return 'outlook.live.com';
            case 'icloud.com':
            case 'me.com':
            case 'mac.com':
                return 'www.icloud.com/mail';
            case 'aol.com':
                return 'mail.aol.com';
            case 't-online.de':
                return 'email.t-online.de';
            case 'web.de':
                return 'web.de/mails';
            case 'gmx.de':
                return 'www.gmx.net/mail';
            case 'protonmail.com':
            case 'proton.me':
                return 'mail.proton.me';
            default:
                return domainFromEmail;
        }
}
